import { useEffect, useRef, type ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "@/components/design/Button";

/** Shared surface for personal extraction and the organizational review-first flow. */
export function ExtractionDialogFrame({ id, title, children, footer, onClose, open = true,
  preventClose = false, dataGraphql, closeId = `${id}-close`,
}: {
  id: string; title: ReactNode; children: ReactNode; footer: ReactNode; onClose: () => void;
  open?: boolean; preventClose?: boolean; dataGraphql?: string; closeId?: string;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = ref.current;
    if (open && !dialog?.open) dialog?.showModal();
    else if (!open && dialog?.open) dialog.close();
  }, [open]);
  return <dialog ref={ref} id={id} aria-label={typeof title === "string" ? title : undefined}
    data-graphql={dataGraphql}
    onCancel={event => { event.preventDefault(); if (!preventClose) onClose(); }}
    className="fixed inset-0 m-auto max-h-[calc(100dvh-2rem)] w-[calc(100%-2rem)] max-w-[640px] overflow-hidden rounded-md border-0 bg-page p-0 shadow-xl ring-1 ring-ink/10 backdrop:bg-ink/30 backdrop:backdrop-blur-[1px]">
    <div className="flex max-h-[calc(100dvh-2rem)] flex-col">
      <div className="flex shrink-0 items-center justify-between gap-3 border-b border-ink/10 px-5 py-3">
        <div className="min-w-0">
          <div className="smycles-field-label text-ink-muted"><FormattedMessage id="save.extraction.poweredBy" defaultMessage="Powered by smycles AI" /></div>
          <div className="font-serif text-smycles-display-s leading-tight">{title}</div>
        </div>
        <Button id={closeId} variant="secondary" onClick={onClose} disabled={preventClose}
          className="px-3 py-1 text-smycles-micro disabled:opacity-40">
          <FormattedMessage id="common.close" defaultMessage="Close" />
        </Button>
      </div>
      <div className="min-h-0 flex-1 space-y-5 overflow-y-auto p-5">{children}</div>
      <div className="shrink-0">{footer}</div>
    </div>
  </dialog>;
}
